var _style, _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEzcanvasLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 147.4 136.4",
    style: {
      enableBackground: "new 0 0 147.4 136.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#66CCFF;stroke-miterlimit:10;}\n\t.st1{fill:#66CCFF;}\n")), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "14,135.7 0.5,130.3 0.5,5.5 14,0.7 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M16.3,0.4v135.9l131.1-6V13.5L16.3,0.4z M75.3,119.7H32.7V22.1h41.2v18.1h-26v20.3h24.5v18H47.9v23.2h27.4 V119.7z M133.2,119.7H81.3v-11.8L113.1,41v-0.6H84.3V22.1h48.4v12.8l-31.1,66v0.6h31.6L133.2,119.7L133.2,119.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEzcanvasLogoIcon);
export default __webpack_public_path__ + "static/media/ezcanvas_logo_icon.9fb3c1e1eaa55bf4842170698666ef13.svg";
export { ForwardRef as ReactComponent };